<!--
* @Name：对账单发票信息
* @Author: 刘玉
* @Date: 2021-12-06 13:54:27
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-06 13:54:27
-->
<template>
  <div>
    <hi-cell title="开票日期：" :value="invoiceDate"></hi-cell>
    <hi-cell title="开票人：" :value="drawerName"></hi-cell>
    <hi-card v-for="(item, index) in invoiceList" :key="item.invoiceNo" :row-index="index + 1">
      <van-row>
        <span>发票号：</span>
        <span>{{ item.invoiceNo }}</span>
      </van-row>
      <van-row>
        <span>未税金额：</span>
        <span>{{ item.noTaxAmount }}</span>
      </van-row>
      <van-row>
        <span>税额：</span>
        <span>{{ item.taxAmount }}</span>
      </van-row>
      <van-row>
        <span>价税合计：</span>
        <span>{{ item.priceTaxTotal }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'InvoiceInfo',
  props: {
    invoiceDate: {
      type: String
    },
    drawerName: {
      type: String
    },
    invoiceList: {
      type: Array,
      default: () => []
    }
  }
}
</script>
